import React from "react";
import { ASSETS } from "../../data/assets";
import { cn } from "../../lib/utils";

// Floating clouds layer for playful backgrounds
export function CloudsLayer({ className }) {
  return (
    <div className={cn("pointer-events-none absolute inset-0 overflow-hidden", className)} aria-hidden="true">
      <img src={ASSETS.cloud1} alt="" className="absolute -top-2 left-[4%] w-28 sm:w-40 opacity-95 animate-float-slow" />
      <img src={ASSETS.cloud2} alt="" className="absolute top-10 right-[6%] w-24 sm:w-36 opacity-95 animate-float" />
      <img src={ASSETS.cloud3} alt="" className="absolute top-24 left-[30%] w-20 sm:w-28 opacity-90 animate-float-slow" />
      <img src={ASSETS.cloud4} alt="" className="absolute top-4 right-[34%] w-16 sm:w-24 opacity-90 animate-float" />
    </div>
  );
}

// Bottom beach/grass strip used at the base of hero sections
export function BeachFooterStrip() {
  return (
    <div className="pointer-events-none absolute bottom-0 left-0 right-0" aria-hidden="true">
      <img src={ASSETS.bushes1} alt="" className="w-full object-cover h-10 sm:h-16 object-bottom" />
    </div>
  );
}

// Small floating decorative image
export function FloatDeco({ src, className, delay = 0, float = "float" }) {
  return (
    <img
      src={src}
      alt=""
      aria-hidden="true"
      style={{ animationDelay: `${delay}s` }}
      className={cn(`pointer-events-none absolute animate-${float}`, className)}
    />
  );
}
